import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SUPABASE_URL, supabaseHeaders } from '../supabase';
import { uploadPoster } from '../utils/imageUpload';

function BooksForm({ onClose }) {
  const navigate = useNavigate();
  const location = useLocation();
  const prefill = location.state || {};
  const [todoItemId] = useState(prefill.todoItemId || null);
  const [prefillPosterUrl] = useState(prefill.posterUrl || null);
  const [form, setForm] = useState({
    title: prefill.title || '',
    author: prefill.author || '',
    rating: '',
    thoughts: '',
    comic: false,
    marvel: false,
    dc: false,
  });
  const [poster, setPoster] = useState(null);
  const [posterPreview, setPosterPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title || !form.rating) {
      setStatus('Please fill in a title and rating.');
      return;
    }

    setLoading(true);
    setStatus('');

    try {
      let posterUrl = null;
      if (poster) posterUrl = await uploadPoster(poster);
      else if (prefillPosterUrl) posterUrl = prefillPosterUrl;

      const payload = {
        title: form.title,
        rating: parseFloat(form.rating),
        comic: form.comic,
        marvel: form.marvel,
        dc: form.dc,
        thoughts: form.thoughts || '',
      };

      if (form.author) payload.author = form.author;
      if (posterUrl) payload.poster_url = posterUrl;

      const res = await fetch(`${SUPABASE_URL}/rest/v1/books`, {
        method: 'POST',
        headers: { ...supabaseHeaders(true), Prefer: 'return=representation' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error('Failed to create');

      if (todoItemId) {
        await fetch(`${SUPABASE_URL}/rest/v1/todo_books?id=eq.${todoItemId}`, {
          method: 'DELETE',
          headers: supabaseHeaders(true),
        });
      }

      setStatus('Saved :D');
      if (onClose) {
        setTimeout(() => onClose(), 1500);
      } else {
        setTimeout(() => navigate('/Books'), 1500);
      }
    } catch (err) {
      console.error(err);
      setStatus(`Something went wrong: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (onClose) {
    return (
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <h2 style={{ fontFamily: 'angelWish', fontSize: '2rem', letterSpacing: '0.06em', marginBottom: 0 }}>Add Book</h2>
        <div className="form-group">
          <label>Title *</label>
          <input type="text" name="title" value={form.title} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label>Author</label>
          <input type="text" name="author" value={form.author} onChange={handleChange} />
        </div>

        <div className="form-group">
          <label>Rating *</label>
          <input
            type="number"
            name="rating"
            value={form.rating}
            onChange={handleChange}
            min="1"
            max="10"
            step="0.1"
            required
          />
        </div>

        <div className="form-group">
          <label>Thoughts</label>
          <textarea name="thoughts" value={form.thoughts} onChange={handleChange} rows={4} />
        </div>

        <div className="form-group">
          <label>Cover</label>
          {(posterPreview || (prefillPosterUrl && !poster)) && (
            <img src={posterPreview || prefillPosterUrl} alt="cover" style={{ width: 80, borderRadius: 4, marginBottom: '0.4rem' }} />
          )}
          <input type="file" accept="image/*" onChange={(e) => { const f = e.target.files[0]; setPoster(f); setPosterPreview(f ? URL.createObjectURL(f) : null); }} />
        </div>

        <div className="form-group">
          <label>Comic/Book</label>
          <div className="form-checkboxes">
            <label><input type="radio" name="comic" checked={!form.comic} onChange={() => setForm(prev => ({ ...prev, comic: false }))} /> Book</label>
            <label><input type="radio" name="comic" checked={form.comic} onChange={() => setForm(prev => ({ ...prev, comic: true }))} /> Comic</label>
          </div>
        </div>

        <div className="form-group">
          <label>Marvel/DC</label>
          <div className="form-checkboxes">
            <label><input type="checkbox" name="marvel" checked={form.marvel} onChange={handleChange} /> Marvel</label>
            <label><input type="checkbox" name="dc" checked={form.dc} onChange={handleChange} /> DC</label>
          </div>
        </div>

        {status && <p className="form-status">{status}</p>}
        <div className="edit-modal-actions">
          <button type="button" className="form-submit" onClick={onClose} style={{ background: 'white', color: 'black', WebkitTextFillColor: 'black' }}>Cancel</button>
          <button type="submit" disabled={loading} className="form-submit">
            {loading ? 'Loading...' : 'Add Book'}
          </button>
        </div>
      </form>
    );
  }

  return (
    <div className="app-container">
      <form onSubmit={handleSubmit} className="movie-form">
        <h1 style={{ fontFamily: 'angelWish', fontSize: '4rem', letterSpacing: '0.06em', marginTop: 0, marginBottom: 0 }}>Add Book</h1>
        <div className="form-group">
          <label>Title *</label>
          <input type="text" name="title" value={form.title} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label>Author</label>
          <input type="text" name="author" value={form.author} onChange={handleChange} />
        </div>

        <div className="form-group">
          <label>Rating *</label>
          <input
            type="number"
            name="rating"
            value={form.rating}
            onChange={handleChange}
            min="1"
            max="10"
            step="0.1"
            required
          />
        </div>

        <div className="form-group">
          <label>Thoughts</label>
          <textarea name="thoughts" value={form.thoughts} onChange={handleChange} rows={4} />
        </div>

        <div className="form-group">
          <label>Cover</label>
          {(posterPreview || (prefillPosterUrl && !poster)) && (
            <img src={posterPreview || prefillPosterUrl} alt="cover" style={{ width: 80, borderRadius: 4, marginBottom: '0.4rem' }} />
          )}
          <input type="file" accept="image/*" onChange={(e) => { const f = e.target.files[0]; setPoster(f); setPosterPreview(f ? URL.createObjectURL(f) : null); }} />
        </div>

        <div className="form-group">
          <label>Comic/Book</label>
          <div className="form-checkboxes">
            <label><input type="radio" name="comic" checked={!form.comic} onChange={() => setForm(prev => ({ ...prev, comic: false }))} /> Book</label>
            <label><input type="radio" name="comic" checked={form.comic} onChange={() => setForm(prev => ({ ...prev, comic: true }))} /> Comic</label>
          </div>
        </div>

        <div className="form-group">
          <label>Marvel/DC</label>
          <div className="form-checkboxes">
            <label><input type="checkbox" name="marvel" checked={form.marvel} onChange={handleChange} /> Marvel</label>
            <label><input type="checkbox" name="dc" checked={form.dc} onChange={handleChange} /> DC</label>
          </div>
        </div>

        <button type="submit" disabled={loading} className="form-submit">
          {loading ? 'Loading...' : 'Add Book'}
        </button>

        {status && <p className="form-status">{status}</p>}
      </form>
    </div>
  );
}

export default BooksForm;
